import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import Config from '@/config';
import CommonUtil from '@/utils/CommonUtil';
import SessionUtil from '@/utils/SessionUtil';
import AssetsUtil from '@/utils/AssetsUtil';
import RouterUtil from '@/utils/RouterUtil';
import StorageUtil from '@/utils/StorageUtil';
import { closeToast, showConfirmDialog, showDialog, showLoadingToast, showSuccessToast, showToast } from 'vant';
import ReserveForm from '@/view/components/reserve-form/reserve-form';
import ProxyForm from '@/view/components/proxy-form/proxy-form';
import VoiceForm from '@/view/components/voice-form/voice-form';
import OrderApi from '@/api/order-api';
import VehicleApi from '@/api/vehicle-api';
import AMapUtil from '@/utils/AMapUtil';
export default {
  name: 'index',
  components: {
    VoiceForm,
    ProxyForm,
    ReserveForm
  },
  computed: {
    CommonUtil() {
      return CommonUtil;
    }
  },
  setup() {
    const noQueryAddress = ref(false);
    const multiCitySupport = ref(true);
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const weather = shallowRef();
    const position = shallowRef(Config.defaultPosition);
    const cityName = shallowRef('');
    const cityCode = shallowRef('');
    const lastCityCode = shallowRef('');
    const orderCityCode = shallowRef('');
    const showWeather = shallowRef(false);
    const cityWeather = shallowRef('');
    const cityWeatherIcon = shallowRef(require('@/assets/icon/weather/default.svg'));
    const driverMarkers = shallowRef();
    const userData = ref();
    const startAddress = ref('正在获取上车点位置...');
    const startPosition = ref([]);
    const endAddress = ref('您要去哪里？');
    const endPosition = ref([]);
    const reserve = ref(false);
    const showReserveForm = ref(false);
    const reserveDay = ref(0);
    const reserveDate = ref();
    const reserveTime = ref(['12', '00']);
    const proxy = ref(false);
    const showProxyForm = ref(false);
    const proxyPriorityContactPassenger = ref(true);
    const proxyPassengerMobile = ref();
    const proxyPassengerName = ref();
    const waitPayOrderCount = ref(0);
    const hasWaitDispatchOrder = ref(false);
    const isMorningRushHour = ref(false);
    const isEveningRushHour = ref(false);
    const voice = ref(false);
    const showVoiceForm = ref(false);
    return {
      noQueryAddress,
      multiCitySupport,
      map,
      geolocation,
      geocoder,
      weather,
      position,
      cityName,
      cityCode,
      lastCityCode,
      orderCityCode,
      showWeather,
      cityWeather,
      cityWeatherIcon,
      driverMarkers,
      userData,
      startAddress,
      startPosition,
      endAddress,
      endPosition,
      reserve,
      showReserveForm,
      reserveDay,
      reserveDate,
      reserveTime,
      proxy,
      showProxyForm,
      proxyPriorityContactPassenger,
      proxyPassengerMobile,
      proxyPassengerName,
      waitPayOrderCount,
      hasWaitDispatchOrder,
      isMorningRushHour,
      isEveningRushHour,
      voice,
      showVoiceForm
    };
  },
  mounted() {
    if (StorageUtil.get('reserveMode') === 'true') {
      this.showReserveForm = true;
      StorageUtil.remove('reserveMode');
    }
    if (StorageUtil.get('proxyMode') === 'true') {
      this.showProxyForm = true;
      StorageUtil.remove('proxyMode');
    }
    if (StorageUtil.get('voiceMode') === 'true') {
      this.showVoiceForm = true;
      StorageUtil.remove('voiceMode');
    }
    //早晚高峰判断时间
    const peakHoursDate = new Date();
    //判断是否为早高峰
    this.isMorningRushHour = peakHoursDate.getHours() === 7 || peakHoursDate.getHours() === 8 && peakHoursDate.getMinutes() <= 30;
    //判断是否为晚高峰
    this.isEveningRushHour = peakHoursDate.getHours() === 16 && peakHoursDate.getMinutes() >= 30 || peakHoursDate.getHours() === 17 && peakHoursDate.getMinutes() <= 30;
    //DOM初始化完成进行地图初始化
    this.initMap();
    this.getProgressOrder();
    this.getWaitPayOrder();
    this.getWaitDispatchOrder();
  },
  activated() {
    const that = this;
    try {
      this.userData = StorageUtil.getObject('userData');
      const addressData = StorageUtil.getObject('addressData');
      const cityData = StorageUtil.getObject('cityData');
      if (addressData) {
        if (addressData.type === 'start') {
          this.orderCityCode = addressData.cityCode;
          this.startAddress = addressData.address;
          this.startPosition = addressData.position;
          this.noQueryAddress = true;
          this.cityName = addressData.cityName;
          this.map.setCenter(this.startPosition, true);
        }
        if (addressData.type === 'end') {
          this.endAddress = addressData.address && addressData.address.length > 1 ? addressData.address : '您要去哪里？';
          this.endPosition = addressData.position;
        }
        if (this.startPosition && this.endPosition && this.startPosition.length === 2 && this.endPosition.length === 2) {
          setTimeout(function () {
            StorageUtil.setObject('orderInitiateData', {
              orderCityCode: that.orderCityCode,
              startAddress: that.startAddress,
              startPosition: that.startPosition,
              endAddress: that.endAddress,
              endPosition: that.endPosition,
              reserve: that.reserve,
              reserveDay: that.reserveDay,
              reserveDate: that.reserveDate,
              reserveTime: that.reserveTime,
              proxy: that.proxy,
              proxyPriorityContactPassenger: that.proxyPriorityContactPassenger,
              proxyPassengerMobile: that.proxyPassengerMobile,
              proxyPassengerName: that.proxyPassengerName
            });
            RouterUtil.go('/order/initiate');
          }, 1000);
        }
      } else if (cityData) {
        this.cityCode = cityData.id;
        this.cityName = cityData.name;
        this.position = cityData.center;
        this.map.setCenter(this.position, true);
        this.map.setZoom(cityData.zoom, true);
      } else {
        this.initMap();
      }
      this.getProgressOrder();
      this.getWaitPayOrder();
      this.getWaitDispatchOrder();
    } catch (e) {
      console.log(e);
    } finally {
      StorageUtil.remove('addressData');
      StorageUtil.remove('cityData');
    }
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Weather']
      }).then(AMap => {
        this.map = new AMap.Map('map', {
          //设置地图容器ID
          viewMode: '2D',
          //是否为3D地图模式
          zoom: Config.defaultMapZoom,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.weather = new AMap.Weather();
        this.map.on('moveend', function () {
          that.position = [that.map.getCenter().getLng(), that.map.getCenter().getLat()];
          that.getNearDriver();
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getAddress(this.position);
        this.getCurrentPosition();
        this.getNearDriver();
      }).catch(e => {
        console.error(e);
      });
    },
    getCurrentPosition() {
      const that = this;
      that.startAddress = '正在获取上车点位置...';
      try {
        this.geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            that.position = [result.position.getLng(), result.position.getLat()];
          } else {
            that.position = Config.defaultPosition;
          }
          that.map.setCenter(that.position);
          that.getAddress(that.position, true);
          that.getNearDriver();
        });
      } catch (e) {
        that.position = Config.defaultPosition;
        that.map.setCenter(that.position);
        that.getAddress(that.position);
        that.getNearDriver();
      }
    },
    getAddress(position, isCurrentPosition) {
      const that = this;
      that.startAddress = '正在获取上车点位置...';
      AMapUtil.getAddress(this.geocoder, position).then(function (result) {
        if (result.success) {
          that.cityCode = result.adCode;
          that.orderCityCode = result.adCode;
          that.cityName = result.cityName;
          that.startAddress = result.showAddress;
          that.startPosition = JSON.parse(JSON.stringify(position));
          if (that.cityCode !== that.lastCityCode) {
            that.getWeather(that.cityCode);
          }
          that.lastCityCode = that.cityCode;
          if (that.startAddress.length < 1) {
            that.startAddress = '未知的上车点位置';
          }
          if (isCurrentPosition) {
            var _result$result;
            StorageUtil.setObject('currentPosition', {
              provinceName: (_result$result = result.result) === null || _result$result === void 0 || (_result$result = _result$result.regeocode) === null || _result$result === void 0 || (_result$result = _result$result.addressComponent) === null || _result$result === void 0 ? void 0 : _result$result.province,
              cityName: result.cityName,
              districtName: result.districtName,
              address: that.startAddress,
              position: that.position
            });
          }
        }
      }).catch(function (error) {
        that.cityName = '未知地区';
        that.startAddress = '未知的上车点位置';
        console.error('根据经纬度查询地址失败：' + error);
      });
    },
    getWeather(cityCode) {
      const that = this;
      that.weather.getLive(cityCode, function (err, data) {
        if (!err) {
          if (data.weather && data.temperature) {
            that.showWeather = true;
            that.cityWeather = data.temperature + '℃';
            that.cityWeatherIcon = AssetsUtil.getWeatherIcon(data.weather);
          } else {
            that.showWeather = false;
          }
        } else {
          that.showWeather = false;
        }
      });
    },
    goWaitPayOrder() {
      RouterUtil.go('/order/list?waitPay');
    },
    goCalling() {
      RouterUtil.go('/order/calling');
    },
    goSelectAddress(type) {
      if (this.hasWaitDispatchOrder) {
        showToast('当前正在为您呼叫附近的司机');
        return;
      }
      StorageUtil.setObject('positionData', {
        type: type,
        position: this.position
      });
      RouterUtil.go('/address');
    },
    goUserCenter() {
      if (SessionUtil.isLogin()) {
        RouterUtil.go('/user');
      } else {
        RouterUtil.go('/login');
      }
    },
    goSelectCity(type) {
      if (this.hasWaitDispatchOrder) {
        showToast('当前正在为您呼叫附近的司机');
        return;
      }
      if (this.multiCitySupport) {
        RouterUtil.go('/city', false, this.$route.path);
      }
    },
    clickShowReserveForm() {
      if (this.hasWaitDispatchOrder) {
        showToast('当前正在为您呼叫附近的司机');
        return;
      }
      this.showReserveForm = !this.showReserveForm;
    },
    clickShowProxyForm() {
      if (this.hasWaitDispatchOrder) {
        showToast('当前正在为您呼叫附近的司机');
        return;
      }
      this.showProxyForm = !this.showProxyForm;
    },
    clickShowVoiceForm() {
      if (this.hasWaitDispatchOrder) {
        showToast('当前正在为您呼叫附近的司机');
        return;
      }
      this.showVoiceForm = !this.showVoiceForm;
    },
    goReturnTrip() {
      RouterUtil.go('/return-trip');
    },
    goDesignatedDriving() {
      RouterUtil.go('/designated-driving');
    },
    reserveNowClick() {
      this.reserve = false;
      this.showReserveForm = false;
    },
    reserveEnterClick(reserveDay, reserveTime, reserveDate) {
      this.reserveDay = reserveDay;
      this.reserveTime = reserveTime;
      this.reserveDate = reserveDate;
      this.reserve = true;
      this.showReserveForm = false;
    },
    proxySelfClick() {
      this.proxy = false;
      this.showProxyForm = false;
    },
    proxyEnterClick(proxyPriorityContactPassenger, proxyPassengerMobile, proxyPassengerName) {
      this.proxyPriorityContactPassenger = proxyPriorityContactPassenger;
      this.proxyPassengerMobile = proxyPassengerMobile;
      this.proxyPassengerName = proxyPassengerName;
      this.proxy = true;
      this.showProxyForm = false;
    },
    voiceEnterCallback(status, data) {
      if (status) {
        this.showVoiceForm = false;
        StorageUtil.setObject('orderInitiateData', {
          startAddress: data.address,
          startPosition: [data.lng, data.lat]
        });
        RouterUtil.go('/order/calling');
      } else {
        showDialog({
          message: data
        });
      }
    },
    getNearDriver() {
      const that = this;
      if (that.driverMarkers && that.driverMarkers.length) {
        that.map.remove(that.driverMarkers);
      }
      that.driverMarkers = [];
      VehicleApi.getVehicles(that.position[0], that.position[1]).then(function (result) {
        if (result.vehicles) {
          const vehicles = result.vehicles;
          for (let i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i];
            // AMap.convertFrom([vehicle.longitude, vehicle.latitude], 'baidu', function (status, result) {
            //   if (result.info === 'ok') {
            //     const lnglat = result.locations[0];
            //     const driverIcon = new AMap.Icon({
            //       image: require('@/assets/icon/map/taxi-top-view.png'),
            //       size: [26, 26],
            //       imageSize: [26, 26],
            //     });
            //     const driverMarker = new AMap.Marker({
            //       position: lnglat,
            //       icon: driverIcon,
            //       offset: new AMap.Pixel(-13, -30)
            //     });
            //     that.map.add(driverMarker);
            //     that.driverMarkers.push(driverMarker);
            //   }
            // });
            const lnglat = [vehicle.longitude, vehicle.latitude];
            const driverIcon = new AMap.Icon({
              image: require('@/assets/icon/map/taxi-top-view.png'),
              size: [26, 26],
              imageSize: [26, 26]
            });
            const driverMarker = new AMap.Marker({
              position: lnglat,
              icon: driverIcon,
              offset: new AMap.Pixel(-13, -30)
            });
            that.map.add(driverMarker);
            that.driverMarkers.push(driverMarker);
          }
        }
      });
    },
    getProgressOrder() {
      var _SessionUtil$getUserT;
      if (SessionUtil.getUserToken() && ((_SessionUtil$getUserT = SessionUtil.getUserToken()) === null || _SessionUtil$getUserT === void 0 ? void 0 : _SessionUtil$getUserT.length) > 0) {
        OrderApi.getProgressOrder().then(function (result) {
          if (result.orderData) {
            StorageUtil.setObject('orderData', result.orderData);
            RouterUtil.go('/order/progress');
          }
        }).catch(function (error) {});
      }
    },
    getWaitPayOrder() {
      var _SessionUtil$getUserT2;
      if (SessionUtil.getUserToken() && ((_SessionUtil$getUserT2 = SessionUtil.getUserToken()) === null || _SessionUtil$getUserT2 === void 0 ? void 0 : _SessionUtil$getUserT2.length) > 0) {
        const that = this;
        OrderApi.getWaitPayOrders().then(function (result) {
          if (result.success) {
            that.waitPayOrderCount = result.orders && result.orders.length ? result.orders.length : 0;
          } else {
            that.waitPayOrderCount = 0;
          }
        }).catch(function (error) {
          that.waitPayOrderCount = 0;
        });
      }
    },
    getWaitDispatchOrder() {
      var _SessionUtil$getUserT3;
      if (SessionUtil.getUserToken() && ((_SessionUtil$getUserT3 = SessionUtil.getUserToken()) === null || _SessionUtil$getUserT3 === void 0 ? void 0 : _SessionUtil$getUserT3.length) > 0) {
        const that = this;
        OrderApi.getWaitDispatchOrder().then(function (result) {
          that.hasWaitDispatchOrder = !!result.response.data.data;
          if (that.hasWaitDispatchOrder) {
            StorageUtil.setObject('orderInitiateData', {
              startAddress: result.orderData.departure_address,
              startPosition: [result.orderData.departure_address_longitude, result.orderData.departure_address_latitude],
              endAddress: result.orderData.destination_address,
              endPosition: [result.orderData.destination_address_longitude, result.orderData.destination_address_latitude]
            });
          }
        }).catch(function (error) {
          that.hasWaitDispatchOrder = false;
        });
      }
    }
  }
};